<template>
  <div class="key-information">
    <!-- button area -->
    <div class="button-area">
      <!-- <el-button  type="primary" @click="smsDialogFormVisible = !smsDialogFormVisible">发送短信</el-button> -->
      <el-button  type="primary" @click="handleToRepayPlan"
        >还款计划</el-button
      >
      <!-- <el-button
        
        type="primary"
        @click="deductDialogVisible"
      >扣款</el-button> -->
      <el-button
        
        type="primary"
        @click="labelDialogFormVisible = !labelDialogFormVisible"
        >添加标签</el-button
      >
      <!-- <el-button v-if="currentUser.role === 3"  type="primary"
        @click="DialogFormVisible = !DialogFormVisible">减免</el-button> -->
      <!-- <el-button v-if="currentUser.role === 3"  type="primary" @click="setSpecialTask">特殊队列</el-button> -->
      <el-button v-if="currentUser.role === 1 || currentUser.role === 2 || currentUser.role === 3 || currentUser.role === 9"  type="primary" @click="operatorSpecialQueue"
        >{{
          taskInfo.isSpecialQueue === "1" ? "移出" : "加入"
        }}特殊队列</el-button
      >
      <el-button
        
        type="primary"
        @click="divisionTasksDialog"
        v-if="currentUser.role === 3 || currentUser.role === 2"
        >分案</el-button
      >
      <el-button  type="primary" @click="updateBillinfo"
        >更新案件</el-button
      >
      <el-button  type="primary" @click="baoAnVisible = true"
        >报案</el-button
      >
    </div>

    <el-dialog :visible.sync="baoAnVisible" width="30%" @close="cancelBaoAn('baoAnForm')">
      <el-form ref="baoAnForm" :model="baoAnForm" :rules="baoAnRules" label-width="80px">
        <el-form-item label="报案原因" prop="caseRean">
          <el-cascader
            :show-all-levels="false"
            placeholder="请选择报案原因"
            v-model="caseRean"
            :options="caseReanList"
            :props="{ expandTrigger: 'hover' }"
            @change="caseReanChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="报案描述" prop="caseNote">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入报案描述"
            v-model="baoAnForm.caseNote">
          </el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left: 80px;">
        <el-button type="primary" @click="submitBaoAn('baoAnForm')"
          >提交</el-button
        >
        <el-button @click="cancelBaoAn('baoAnForm')"
          >关闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="divisionTasksVisible" width="30%">
      <el-autocomplete
        style="width: 100%"
        v-model="operator"
        :fetch-suggestions="querySearch"
        placeholder="请输入处理人"
        @select="handleSelect"
        @change="operatorChange"
      ></el-autocomplete>
      <div style="text-align: right; margin-top: 20px">
        <el-button type="primary" @click="divisionTasks"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- dialogs -->
    <conditions
      v-if="showConditions"
      :visible="showConditions"
      :task-id="taskId"
      @hide="hideDialogVisible"
    />
    <item-dialog-sms
      v-if="smsDialogFormVisible"
      :visible="smsDialogFormVisible"
      :task-id="taskId"
      :loan-id="id"
      @hide="hideDialogVisible"
    />

    <item-dialog-deduct
      v-if="deductDialogFormVisible"
      :visible="deductDialogFormVisible"
      :task-id="taskId"
      :deduct-type="''"
      @hide="hideDialogVisible"
    />

    <item-dialog-deduct
      v-if="DialogFormVisible"
      :visible="DialogFormVisible"
      :task-id="taskId"
      :deduct-type="'reduce'"
      @hide="hideDialogVisible"
    />

    <item-dialog-label
      v-if="labelDialogFormVisible"
      :visible="labelDialogFormVisible"
      :task-id="taskId"
      @hide="hideDialogVisible"
    />

    <!-- user info -->
    <item-user-info :task-id="taskId" />

    <!-- task info -->
    <!-- <item-task-info :task-id="taskId" /> -->

    <!-- work log info -->
    <item-work-log-info :loan-id="id" :task-id="taskId" />

    <Footer :task-id="taskId" class="footer-content" />
  </div>
</template>

<script>
import * as components from "../components";
import itemDialogLabel from "./itemDialogLabel.vue";
import conditions from "../conditions.vue";
import Footer from "./footer";
import { mapActions, mapGetters } from "vuex";
import {
  setSpecialTask,
  specialQueueOperator,
  manualDivisionTasks,
  updateLatestBillinfo,
  getCaseRean,
  getCaseReanByFatherId,
  saveMertCase
} from "@/api/task.js";
import { getUser } from "@/api/manage";

export default {
  name: "information",
  components: {
    "item-user-info": components.userInfo,
    // 'item-task-info': components.taskInfo,
    "item-work-log-info": components.workLogInfo,
    "item-dialog-sms": components.dialogSms,
    "item-dialog-deduct": components.dialogDeduct,
    "item-dialog-label": itemDialogLabel,
    "conditions": conditions,
    Footer,
  },
  data() {
    return {
      smsDialogFormVisible: false,
      deductDialogFormVisible: false,
      labelDialogFormVisible: false,
      DialogFormVisible: false,
      // 分案
      divisionTasksVisible: false,
      operator: "",
      bindingAgentId: "",
      // 报案
      baoAnVisible: false,
      caseRean: '',
      caseReanList: [],
      baoAnForm: {
        caseRean: '',
        caseNote: '',
        taskId: ''
      },
      baoAnRules: {
        caseRean: [{ required: true, message: '请选择报案原因', trigger: 'change' }],
        caseNote: [{ required: true, message: '请输入报案描述', trigger: 'blur' }]
      },
      // 还款计划弹窗
      showConditions: false,
    };
  },
  computed: {
    ...mapGetters(["taskInfo", "currentUser"]),
    id() {
      return this.$route.params.loanId;
    },
    taskId() {
      return this.$route.params.taskId;
    },
    status() {
      return this.$route.params.status;
    },
  },
  async created() {
    this.baoAnForm.taskId = this.taskId;
    await this.fetchTaskInfo({ taskId: this.taskId });
    await getCaseRean().then((res) => {
      if (res.data && res.data.length > 0) {
        this.caseReanList = []
        res.data.map((item, index) => {
          if (item.isHaveChildNode == '1') {
            this.caseReanList.push({
              value: item.pkid,
              label: item.caseName,
              children: []
            })
            this.getCaseReanByFatherIdMethod(item.pkid, this.caseReanList[index].children)
          } else {
            this.caseReanList.push({
              value: item.pkid,
              label: item.caseName
            })
          }
        })
      }
    })
  },
  methods: {
    caseReanChange(value) {
      this.baoAnForm.caseRean = value[value.length - 1]
    },
    async getCaseReanByFatherIdMethod(pkid, list) {
      await getCaseReanByFatherId({fatherId: pkid}).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.map((item, index) => {
            if (item.isHaveChildNode == '1') {
              list.push({
                value: item.pkid,
                label: item.caseName,
                children: []
              })
              this.getCaseReanByFatherIdMethod(item.pkid, list[index].children)
            } else {
              list.push({
                value: item.pkid,
                label: item.caseName
              })
            }
          })
        }
      })
    },
    submitBaoAn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveMertCase(this.baoAnForm).then((res) => {
            if (res.code === "00") {
              this.$message.success(res.data);
              this.cancelBaoAn('baoAnForm')
              return;
            }
            this.$message.warning(res.data);
          })
        }
      });
    },
    cancelBaoAn(formName) {
      this.$refs[formName].resetFields();
      this.caseRean = ''
      this.baoAnVisible = false
    },
    ...mapActions(["fetchTaskInfo"]),
    async setSpecialTask() {
      this.$confirm("是否确认移入特殊队列", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await setSpecialTask({
            userId: this.currentUser.id,
            taskId: this.taskId,
          });
          if (code === "00") return this.$message.success("操作成功");
        })
        .catch(() => {});
    },
    deductDialogVisible() {
      this.deductDialogFormVisible = !this.deductDialogFormVisible;
    },
    hideDialogVisible() {
      this.smsDialogFormVisible = false;
      this.deductDialogFormVisible = false;
      this.labelDialogFormVisible = false;
      this.DialogFormVisible = false;
      this.showConditions = false;
    },
    handleToRepayPlan() {
      // this.$router.push({
      //   name: "conditions",
      //   params: { taskId: this.$route.params.taskId },
      // });
      this.showConditions = true
    },
    // 加入/移出特殊队列
    async operatorSpecialQueue() {
      // type 1 加入  2移出
      const res = await specialQueueOperator({
        taskId: this.taskId,
        operator: this.currentUser.id,
        type: this.status === "NULL" ? "2" : "1",
      });
      if (res.code === "00") {
        this.$message.success(res.data);
        return;
      }
      this.$message.warning(res.data);
    },
    // 分案
    divisionTasksDialog() {
      this.operator = "";
      this.bindingAgentId = "";
      this.divisionTasksVisible = true;
    },
    async divisionTasks() {
      if (!this.bindingAgentId) {
        this.$message.warning("请选择处理人");
        return;
      }
      const res = await manualDivisionTasks({
        taskId: this.taskId,
        operator: this.currentUser.id,
        bindingAgentId: this.bindingAgentId,
      });
      this.divisionTasksVisible = false;
      if (res.code === "00") {
        this.$message.success(res.data);
        return;
      }
      this.$message.warning(res.data);
    },
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.bindingAgentId = item.id;
    },
    operatorChange(val) {
      if (!val) {
        this.bindingAgentId = "";
      }
    },
    // 更新案件
    async updateBillinfo() {
      const res = await updateLatestBillinfo({
        taskId: this.taskId,
      });
      if (res.code === "00") {
        this.$message.success(res.data);
        location.reload()
        return;
      }
      this.$message.warning(res.data);
    },
  },
};
</script>

<style lang="scss">
// #task {
//   .el-card__body {
//     padding: 12px 18px;
//   }
//   .el-table--small td,
//   .el-table--small th {
//     padding: 3px 0;
//   }

//   .contacts-related-info {
//     .el-tabs__item {
//       height: 32px;
//       line-height: 32px;
//     }
//   }

//   .el-card__body,
//   .el-form-item__label,
//   .el-radio__label {
//     font-size: 16px;
//   }
//   .el-input__inner,
//   .el-textarea__inner {
//     padding: 0 8px;
//     line-height: 28px;
//   }
//   .el-form-item--mini.el-form-item,
//   .el-form-item--small.el-form-item {
//     margin-bottom: 8px;
//   }
// }
</style>

<style lang="scss" scoped>
.el-cascader,
.el-textarea {
  width: 80%;
}

.button-area {
  margin-bottom: 12px;
}

.btn-wrapper {
  padding-top: 30px;
  text-align: center;
}
</style>
